// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import Modal from 'modals/Modal';
import LoadingSection from 'components/LoadingSection';
import { setError } from '../redux/main/actions/error';
import { hideModal } from '../redux/main/actions/modal';

type OwnProps = {
  error: Object,
  pastDelay: boolean
};

type Props = { ...$Exact<OwnProps>, setError: Function, hideModal: Function };

class LoadingModal extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    if (this.props.error && !prevProps.error) {
      // Show the error page if loading the modal bundle failed
      this.props.setError(this.props.error, false);
    }
  }

  render() {
    if (this.props.pastDelay) {
      return (
        <Modal onClose={this.props.hideModal}>
          <LoadingSection delay={0} />
        </Modal>
      );
    }
    return null;
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  {
    hideModal,
    setError
  }
)(LoadingModal);
